import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import Select from 'react-select';
import numeral from 'numeral';
import { compose } from 'recompose';

import { loadAnalyticsAssetList, sortAnalyticsAssetList, filterAnalyticsAssetList } from './actions';
import { TRACKED_ASSET, ENGAGEMENT_SCORE, YOUTUBE, INSTAGRAM, SNAPCHAT, FACEBOOK, TWITTER } from '../../utils/static-configuration';
import { setModal } from '../../actions/modal';
import EngagementScoreModal from '../../components/engagement-score-modal';
import AnalyticsAssetListHeader from '../../components/analytics-asset-list-header';
import AnalyticsAssetListTotals from '../../components/analytics-asset-list-totals';
import AnalyticsAssetListContent from '../../components/analytics-asset-list-content';

class AnalyticsAssetList extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    this.props.onLoadAnalyticsAssetList();
  }

  openAssetPage = assetId => () => this.context.router.push(`/analytics/${assetId}`);

  sortAssetList = sortBy => this.props.onSortAnalyticsAssetList({ sortBy: sortBy.value });

  filterAssetList = filterBy => this.props.onFilterAnalyticsAssetList({ filterBy: filterBy.value });

  showModal = docType => () => this.props.onSetModal(docType);

  render() {
    const {
      hasTrackedDeliverables,
      filteredYoutubeVideos,
      filteredInstagramPosts,
      filteredFacebookPosts,
      filteredTwitterPosts,
      sortBy,
      filterBy,
      filterByOptions,
      loading,
      showAnalyticTotals,
      youtubeTotals,
      instagramTotals,
      facebookTotals,
      twitterTotals,
    } = this.props;

    const sortByOptions = [
      { value: 'highestViews', label: 'views (highest)' },
      { value: 'lowestViews', label: 'views (lowest)' },
      { value: 'highestEngagement', label: 'engagement (highest)' },
      { value: 'lowestEngagement', label: 'engagement (lowest)' },
      { value: 'latestLiveDate', label: 'live date (latest)' },
      { value: 'oldestLiveDate', label: 'live date (oldest)' },
    ];

    return (
      <div className="analytics-asset-list">
        { loading &&
          <div className="discussion-preloader">
            <img src="/icons/dyzio-icon.svg" alt="Loading..." />
          </div>
        }
        { hasTrackedDeliverables && !loading &&
          <div>
            <div className="video-list-filtering-container">
              <div className="filter-by">
                <p>Filter videos</p>
                <Select
                  name="filterBy"
                  label=""
                  value={filterBy}
                  className="select"
                  options={filterByOptions}
                  onChange={this.filterAssetList}
                  clearable={false}
                />
              </div>
              <div className="sort-by">
                <p>Sort by</p>
                <Select
                  name="sortBy"
                  label=""
                  value={sortBy}
                  className="select"
                  options={sortByOptions}
                  onChange={this.sortAssetList}
                  clearable={false}
                />
              </div>
            </div>
            <div className="spacer small" />
            <h3>Tracked deliverables</h3>

            { filteredYoutubeVideos.size > 0 &&
              <div>
                <div className="spacer" />
                <AnalyticsAssetListHeader listName={YOUTUBE} listSize={filteredYoutubeVideos.size} showAnalyticTotals={showAnalyticTotals} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} />
                <div className="asset-list">
                  {
                    filteredYoutubeVideos.map(trackedAsset => <AnalyticsAssetListContent key={trackedAsset.get('id')} data={trackedAsset} filterBy={filterBy} viewVideo={this.openAssetPage(trackedAsset.get('assetId'))} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} />)
                  }
                </div>
                { showAnalyticTotals && <AnalyticsAssetListTotals listName={YOUTUBE} listSize={filteredYoutubeVideos.size} totals={youtubeTotals} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} /> }
              </div>
            }

            { filteredInstagramPosts.size > 0 &&
              <div>
                <div className="spacer" />
                <AnalyticsAssetListHeader listName={INSTAGRAM} listSize={filteredInstagramPosts.size} showAnalyticTotals={showAnalyticTotals} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} />
                <div className="asset-list">
                  {
                    filteredInstagramPosts.map(trackedAsset => <AnalyticsAssetListContent key={trackedAsset.get('id')} data={trackedAsset} filterBy={filterBy} viewVideo={this.openAssetPage(trackedAsset.get('assetId'))} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} />)
                  }
                </div>
                { showAnalyticTotals && <AnalyticsAssetListTotals listName={INSTAGRAM} listSize={filteredInstagramPosts.size} totals={instagramTotals} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} /> }
              </div>
            }

            { filteredFacebookPosts.size > 0 &&
              <div>
                <div className="spacer" />
                <AnalyticsAssetListHeader listName={FACEBOOK} listSize={filteredFacebookPosts.size} showAnalyticTotals={showAnalyticTotals} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} />
                <div className="asset-list">
                  {
                    filteredFacebookPosts.map(trackedAsset => <AnalyticsAssetListContent key={trackedAsset.get('id')} data={trackedAsset} filterBy={filterBy} viewVideo={this.openAssetPage(trackedAsset.get('assetId'))} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} />)
                  }
                </div>
                { showAnalyticTotals && <AnalyticsAssetListTotals listName={FACEBOOK} listSize={filteredFacebookPosts.size} totals={facebookTotals} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} /> }
              </div>
            }
            { filteredTwitterPosts && (filteredTwitterPosts.size > 0) &&
              <div>
                <div className="spacer" />
                <AnalyticsAssetListHeader listName={TWITTER} listSize={filteredTwitterPosts.size} showAnalyticTotals={showAnalyticTotals} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} />
                <div className="asset-list">
                  {
                    filteredTwitterPosts.map(trackedAsset => (
                      <AnalyticsAssetListContent
                        key={trackedAsset.get('id')}
                        data={trackedAsset}
                        filterBy={filterBy}
                        viewVideo={this.openAssetPage(trackedAsset.get('assetId'))}
                        openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)}
                      />
                    ))
                  }
                </div>
                { showAnalyticTotals && <AnalyticsAssetListTotals listName={TWITTER} listSize={filteredTwitterPosts.size} totals={twitterTotals} openEngagementScoreModal={this.showModal(ENGAGEMENT_SCORE)} /> }
              </div>
            }


            <EngagementScoreModal />
          </div>
        }
        { !hasTrackedDeliverables && !loading &&
          <div>
            <div className="spacer" />
            <div className="box centered">
              <div className="box-content-one">
                <div className="box-content-two">
                  <div className="box-content-three">
                    <div className="spacer" />
                    <h2>
                      You’re not tracking any live deliverables yet.
                      <br />
                      Let’s get started!
                    </h2>
                    <div className="spacer large" />
                    <img src="/graph.svg" alt="let's get started" />
                    <div className="spacer large" />
                    <p>You can currently track Youtube, Facebook and Instagram deliverables. Twitter coming soon!</p>
                    <div className="spacer" />
                    <button className="large rose wide" onClick={this.showModal(TRACKED_ASSET)}><p>Track a deliverable</p></button>
                    <div className="spacer" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userData: state.userData.get('userData'),
  loading: state.analyticsAssetList.get('loading'),
  sortBy: state.analyticsAssetList.get('sortBy'),
  filterBy: state.analyticsAssetList.get('filterBy'),
  filteredYoutubeVideos: state.analyticsAssetList.get('filteredYoutubeVideos'),
  filteredInstagramPosts: state.analyticsAssetList.get('filteredInstagramPosts'),
  filteredFacebookPosts: state.analyticsAssetList.get('filteredFacebookPosts'),
  filteredTwitterPosts: state.analyticsAssetList.get('filteredTwitterPosts'),
  hasTrackedDeliverables: state.analyticsAssetList.get('hasTrackedDeliverables'),
  filterByOptions: state.analyticsAssetList.get('filterByOptions'),
  showAnalyticTotals: state.analyticsAssetList.get('showAnalyticTotals'),
  youtubeTotals: state.analyticsAssetList.get('youtubeTotals'),
  instagramTotals: state.analyticsAssetList.get('instagramTotals'),
  facebookTotals: state.analyticsAssetList.get('facebookTotals'),
});

export function mapDispatchToProps(dispatch) {
  return {
    onSetModal: modalName => dispatch(setModal(modalName)),
    onLoadAnalyticsAssetList: () => dispatch(loadAnalyticsAssetList()),
    onSortAnalyticsAssetList: data => dispatch(sortAnalyticsAssetList(data)),
    onFilterAnalyticsAssetList: data => dispatch(filterAnalyticsAssetList(data)),
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AnalyticsAssetList);



/** WEBPACK FOOTER **
 ** ./src/containers/analytics-asset-list/index.js
 **/